<style lang="scss" scoped>
.slide-11 {
  background-image: url(../../../assets/module1/slide11/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 115px;
  padding-right: 115px;
  padding-top: 80px;
  height: calc(100% - 80px);
}
h1 {
  font-size: 54px;
  color: #c5d43b;
  margin-bottom: 20px;
}
p {
  color: white;
}
.first-para {
  max-width: 610px;
}
.big {
  font-weight: 100;
  font-size: 151px;
  color: #e30613;
  max-width: 1600px;
  text-align: center;
  transform: rotate(-5deg) translateX(162px);
  line-height: 152px;
  display: flex;
  flex-wrap: wrap;
  span {
    margin-left: auto;
    display: block;
  }
}
h3 {
  font-size: 43px;
  max-width: 500px;
  line-height: 52px;
  text-align: left;
  margin-top: 15px;
  margin-left: 30px;
  margin-right: 170px;
}
.second-para {
  max-width: 356px;
  position: absolute;
  right: 580px;
  bottom: 202px;
}
</style>

<template>
  <div class="slide-11">
    <transition name="scale" appear>
      <h1
        v-show="slideIndex == 10"
        class="slide-11-heading"
        v-html="$t('module1.slide11.heading')"
      ></h1>
    </transition>
    <transition name="scale" appear>
      <p v-show="slideIndex == 10" class="first-para delay-1">
        {{ $t("module1.slide11.paragraph") }}
      </p>
    </transition>
    <h1 class="big">
      <transition name="scale" appear>
        <div v-show="slideIndex == 10" class="delay-2">
          {{ $t("module1.slide11.heading2") }}
        </div>
      </transition>
      <br />
      <transition name="scale" appear>
        <SPAN v-show="slideIndex == 10" class="delay-3">000</SPAN>
      </transition>
      <transition name="scale" appear>
        <h3
          class="delay-4"
          v-show="slideIndex == 10"
          v-html="$t('module1.slide11.heading3')"
        ></h3>
      </transition>
    </h1>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 10"
        src="@/assets/module1/slide11/characters-01.png"
        class="chars delay-5"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <p v-show="slideIndex == 10" class="second-para delay-6">
        {{ $t("module1.slide11.paragraph2") }}
      </p>
    </transition>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 10"
        src="@/assets/module1/slide11/ambulance-01.png"
        class="chars delay-7"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
